import { toBase64 } from '../../shared/util/base64';
import LocationAPI from '../locations/LocationAPI';
import { DeviceDataAPIResponse } from './device.model';
import Environment from '../../shared/constants/Environment';

const deviceBaseUrl = Environment.backendAPICommander;
const configBaseUrl = Environment.backendAPIConfig;

export const DeviceAPI = LocationAPI.injectEndpoints({
  endpoints: (build) => ({
    getDeviceByCloudConnectId: build.query<
      DeviceDataAPIResponse | undefined,
      string
    >({
      query: (cloudConnectId) => {
        return {
          url: `${deviceBaseUrl}/cloudConnectID/${cloudConnectId}`,
          method: 'get',
        };
      },
      providesTags: ['device-actions'],
    }),

    getDeviceBySerialNumber: build.query<
      DeviceDataAPIResponse | undefined,
      string
    >({
      query: (serialNumber) => {
        return {
          url: `${deviceBaseUrl}/serialnum/${toBase64(serialNumber)}`,
          method: 'get',
        };
      },
      providesTags: ['device-actions'],
    }),
    setTimezoneCommander: build.mutation<
      string,
      { commanderId: string; timezone: string }
    >({
      query: ({ commanderId, timezone }) => {
        const encodedCommanderId = toBase64(commanderId);
        return {
          url: `${configBaseUrl}/${encodedCommanderId}`,
          method: 'put',
          data: [
            {
              key: 'device-timezone',
              value: timezone,
              type: 'TEXT',
            },
          ],
        };
      },
      invalidatesTags: ['device-actions'],
    }),
  }),
});
